import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../api/services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Team } from '../../../api/models/team';
import { UserService } from '../../../api/services/user.service';
import { Organization } from '../../../api/models/organization';
import { PreferencesService } from '../../../api/services/preferences.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-team',
  templateUrl: './new-team.component.html',
  styleUrls: ['./new-team.component.scss']
})
export class NewTeamComponent implements OnInit {

  newTeam: Team = new Team();

  teamForm: FormGroup;
  organizations: Organization[] = [];
  organizationId: string;
  type = 0;
  specialSelected: string;

  err: string[] = [];
  teamError = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private preferencesService: PreferencesService,
    private toastr: ToastrService
  ) { }

  saveTeam() {
    this.newTeam = this.teamForm.value;
    if (/^\s*$/.test(this.newTeam.name) || this.newTeam.name == null) {
      this.onUpdateError('Team Name cannot be null or blank');
    }else{
      this.newTeam.organization_id = this.organizationId;
      this.newTeam.type = this.type;
      this.authService.createTeam(this.newTeam).subscribe(Response => {
        this.activeModal.close();
      },error => {
        this.teamError = true;
        this.err.push(error.error.message);
      });
    }
  }

  private onUpdateError(error: string) {
    this.toastr.error(error, 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  clearError(){
    this.teamError = false;
    this.err = [];
  }

  setClient(clientId: string) {
    this.organizationId = clientId;
    this.preferencesService.getPreferences('CUSTOMER', this.organizationId).subscribe(prefs => {
      this.specialSelected = prefs['special-fields'].Value;
    });
  }

  setType(type: number) {
    this.type = type;
  }

  ngOnInit() {
    this.teamForm = this.formBuilder.group({
      name: [this.newTeam.name, Validators.required],
      description: [this.newTeam.description],
      allowed_pricing: [this.newTeam.allowed_pricing],
      allowed_availability: [this.newTeam.allowed_availability],
      allowed_create_projects: [this.newTeam.allowed_create_projects],
      allowed_create_master_boms: [this.newTeam.allowed_create_master_boms],
      allowed_report_view: [this.newTeam.allowed_report_view]
    });

    this.userService.getOrganizations().subscribe(orgs => {
      this.organizations = orgs;
    });
  }

  showPermissionsForVerizonAndStandard(): boolean {
    return this.specialSelected === 'Verizon eQuote' || this.specialSelected === 'Standard';
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/new-team/new-team.component.ts